export const freePlans = ['free', 'no_plan']
